import { FormattedMessage } from 'react-intl';
import VaccinesIcon from '@mui/icons-material/Vaccines';

const vaccination = {
  id: 'vaccination',
  title: <FormattedMessage id="Vaccination" />,
  icon: VaccinesIcon,
  type: 'group',
  visible: (roles, isAdmin) => isAdmin || roles.includes('doctor') || roles.includes('nurse'),
  children: [
    {
      id: 'vaccination-management',
      title: <FormattedMessage id="Vaccine Administration" />,
      type: 'item',
      url: '/vaccination/management',
      icon: VaccinesIcon,
      visible: (roles, isAdmin) => isAdmin || roles.includes('doctor') || roles.includes('nurse'),
    },
    {
      id: 'vaccine-management',
      title: <FormattedMessage id="Vaccine Management" />,
      type: 'item',
      url: '/vaccination/vaccine-management',
      icon: VaccinesIcon,
      visible: (roles) => roles.includes('superuser'),
    },
  ],
};

export default vaccination;
